import { TimeOfDayForSlots } from "../stores/queue-store/types";
import { isSameDay } from "./date-utils";

export default function getTimeOfDaysApplicable(date: Date): TimeOfDayForSlots {
  const today = new Date();
  const timeOfDayProvided = date.getTime();

  let dateTimeToConsider: Date = date;
  if (timeOfDayProvided < today.getTime()) {
    dateTimeToConsider = today;
  }

  return getTimeOfDay(dateTimeToConsider);
}

export function getTimeOfDay(date: Date): TimeOfDayForSlots {
  const hourOfTheDay = date.getHours();
  if (hourOfTheDay >= 0 && hourOfTheDay < 12) {
    return "morning";
  } else if (hourOfTheDay >= 12 && hourOfTheDay < 17) {
    return "afternoon";
  } else {
    return "evening";
  }
}

export function getTimeOfDaysForDate(date: Date): TimeOfDayForSlots[] {
  const now = new Date();
  if (isSameDay(date, now)) {
    const hourOfTheDay = now.getHours();
    if (hourOfTheDay >= 0 && hourOfTheDay < 12) {
      return ["morning", "afternoon", "evening"];
    } else if (hourOfTheDay >= 12 && hourOfTheDay < 17) {
      return ["afternoon", "evening"];
    } else {
      return ["evening"];
    }
  }
  return ["morning", "afternoon", "evening"];
}
